export const scrollToCardStart = (rowEl, colIdx, cardWidth, gap) => {
    const targetLeft = colIdx * (cardWidth + gap);

    rowEl.scrollTo({ left: targetLeft });

  };